<script>
    import { slugify } from '@repo/config/Utils';

    /**
     * @typedef {Object} Props
     * @property {any} label
     * @property {string} [as]
     */
    let { label, as = 'li' } = $props();
</script>

<svelte:element this={as} class="floating-menu-row">
    <h2 id={`${slugify(label)}-section-legend`}>{label}</h2>
</svelte:element>

<style>
    .floating-menu-row{
        display:flex;
        flex-direction:row;
        align-items:center;
        justify-content:flex-start;
        flex-shrink:0;
        max-width:20rem;
        color:#eee;
        
    }

    .floating-menu-row h2{
        display:flex;
        flex-grow:10;
        padding-bottom:0.5rem;
        margin:1.25rem 1.5rem 0.75rem 1rem;
        color:inherit;
        flex-shrink:0;
        text-transform:uppercase;
        font-weight:600;
        font-size:0.8rem;
        color:rgb(255, 206, 44);
        border-bottom:1px solid rgb(255, 206, 44);
    }
</style>

